/** @jsxImportSource @emotion/react */
import { CAMPAIGN_STATUS, normalizeStatus } from "../utils";
import t from "../../../theme";

const statusStyles = {
  base: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    borderRadius: 999,
    padding: "7px 12px",
    fontFamily: t.font.family,
    fontSize: "0.78rem",
    fontWeight: 800,
    letterSpacing: 0,
    textTransform: "capitalize",
    "&::before": {
      content: '""',
      width: 8,
      height: 8,
      borderRadius: "50%",
      background: "currentColor",
    },
  },
  small: {
    gap: 4,
    padding: "3px 8px",
    fontSize: "0.6rem",
    boxShadow: "0 2px 6px rgba(15, 23, 42, 0.18)",
    "&::before": {
      width: 5,
      height: 5,
    },
  },
  [CAMPAIGN_STATUS.AVAILABLE]: {
    background: "#ecfdf3",
    color: "#027a48",
  },
  [CAMPAIGN_STATUS.RESERVED]: {
    background: "#fff7ed",
    color: "#c2410c",
  },
  [CAMPAIGN_STATUS.REDEEMED]: {
    background: "#eef4ff",
    color: "#175cd3",
  },
  [CAMPAIGN_STATUS.EXPIRED]: {
    background: "#fef2f2",
    color: "#b91c1c",
  },
};

const labelMap = {
  [CAMPAIGN_STATUS.AVAILABLE]: "Available",
  [CAMPAIGN_STATUS.RESERVED]: "Payment Pending",
  [CAMPAIGN_STATUS.REDEEMED]: "Booked",
  [CAMPAIGN_STATUS.EXPIRED]: "Expired",
};

// The compact card overlay badge is 0.6rem on a narrow image, so the longer
// labels are abbreviated there rather than wrapping over the artwork.
const shortLabelMap = {
  [CAMPAIGN_STATUS.RESERVED]: "Pending",
};

const CampaignStatusBadge = ({ status, size }) => {
  const normalized = normalizeStatus(status);
  return (
    <span
      css={[
        statusStyles.base,
        size === "small" && statusStyles.small,
        statusStyles[normalized],
      ]}
    >
      {(size === "small" && shortLabelMap[normalized]) || labelMap[normalized]}
    </span>
  );
};

export default CampaignStatusBadge;
